/**
 * Grupo imagen + tarjetas colapsables con índice activo único.
 */

import ContentCard from './contentCard'

export default class DynamicImageCard {
	private root: HTMLElement
	private cardsColumn: HTMLElement | null = null
	private activeIndex = 0
	private boundClick: ((e: MouseEvent) => void) | null = null

	constructor(root: HTMLElement) {
		this.root = root
		const raw = parseInt(root.dataset.activeIndex ?? '0', 10)
		this.activeIndex = Number.isNaN(raw) ? 0 : raw
	}

	init(): void {
		this.cardsColumn = this.root.querySelector<HTMLElement>('.hg-dynamic-image-cards__cards')
		if (!this.cardsColumn) return

		this.boundClick = (e: MouseEvent) => this.onCardsClick(e)
		this.cardsColumn.addEventListener('click', this.boundClick)
		this.applyState(this.activeIndex)
	}

	cleanup(): void {
		if (this.boundClick && this.cardsColumn) {
			this.cardsColumn.removeEventListener('click', this.boundClick)
		}
		this.boundClick = null
		this.cardsColumn = null
	}

	private onCardsClick(e: MouseEvent): void {
		const header = (e.target as HTMLElement).closest('.hg-content-card__header')
		if (!header || !this.cardsColumn?.contains(header)) return

		const cardRoot = header.closest<HTMLElement>('.hg-content-card')
		if (!cardRoot) return

		const wrap = header.closest<HTMLElement>('[data-dynamic-image-cards-index]')
		if (!wrap) return

		const idx = parseInt(wrap.getAttribute('data-dynamic-image-cards-index') ?? '0', 10)
		if (Number.isNaN(idx)) return

		const collapsible = cardRoot.classList.contains('is-collapsible')

		if (collapsible && idx === this.activeIndex) {
			e.preventDefault()
			e.stopPropagation()
			return
		}

		if (idx === this.activeIndex) {
			return
		}

		if (collapsible && header instanceof HTMLButtonElement) {
			e.preventDefault()
			e.stopPropagation()
		}

		this.activeIndex = idx
		this.root.dataset.activeIndex = String(idx)
		this.applyState(idx)
		window.setTimeout(() => {
			document.dispatchEvent(new CustomEvent('hg:refresh-scroll'))
		}, 450)
	}

	private applyState(activeIdx: number): void {
		this.root.querySelectorAll<HTMLElement>('.hg-dynamic-image-cards__figure').forEach((fig) => {
			const i = parseInt(fig.getAttribute('data-dynamic-image-cards-index') ?? '-1', 10)
			const on = i === activeIdx
			fig.classList.toggle('is-active', on)
			fig.setAttribute('aria-hidden', on ? 'false' : 'true')
		})

		this.root.querySelectorAll<HTMLElement>('.hg-dynamic-image-cards__card-wrap').forEach((wrap) => {
			const i = parseInt(wrap.getAttribute('data-dynamic-image-cards-index') ?? '-1', 10)
			const card = wrap.querySelector<HTMLElement>('.hg-content-card')
			if (!card) return

			const on = i === activeIdx
			card.classList.toggle('is-active', on)

			if (!card.classList.contains('is-collapsible')) return

			const btn = card.querySelector<HTMLButtonElement>('.hg-content-card__header')
			const body = card.querySelector<HTMLElement>('.hg-content-card__body')
			if (!btn || !body) return

			const expanded = on
			btn.setAttribute('aria-expanded', expanded ? 'true' : 'false')
			if (expanded) {
				body.removeAttribute('inert')
				card.classList.add('is-expanded')
				card.classList.remove('is-collapsed')
			} else {
				body.setAttribute('inert', '')
				card.classList.remove('is-expanded')
				card.classList.add('is-collapsed')
			}
			ContentCard.syncContentCardSkin(card, expanded)
		})
	}
}
